import React from 'react';
import { useTranslation } from 'react-i18next';
import { supportedLanguages } from '../../i18n';

interface LanguageSwitcherProps {
  className?: string;
  showFlag?: boolean;
  showName?: boolean;
  compact?: boolean;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ 
  className = '', 
  showFlag = true,
  showName = true,
  compact = false
}) => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLang = event.target.value;
    i18n.changeLanguage(newLang);
  };

  // Map language codes to 2-letter display codes
  const getDisplayCode = (code: string): string => {
    if (code === 'pt-br') return 'PT';
    if (code === 'enpirate') return '🏴‍☠️';
    if (code === 'engymbro') return '💪';
    if (code === 'enbjj') return '🥋';
    return code.toUpperCase();
  };

  if (compact) {
    return (
      <div className="relative">
        <select
          value={i18n.language}
          onChange={handleLanguageChange}
          className={`appearance-none bg-transparent dark:bg-transparent border border-gray-300 dark:border-gray-600 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pr-6 pl-2 py-1 ${className}`}
          aria-label="Select language"
          style={{ minWidth: '45px' }}
        >
          {supportedLanguages.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {getDisplayCode(lang.code)}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-500">
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    );
  }

  return (
    <select
      value={i18n.language}
      onChange={handleLanguageChange}
      className={`px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
      aria-label="Select language"
    >
      {supportedLanguages.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {showFlag && `${lang.flag} `}
          {showName && lang.name}
        </option>
      ))}
    </select>
  );
};

export default LanguageSwitcher;